<template>
  <div>
    <InnerHeader />
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row align-items-center mb-3">
            <div class="col-md-4">
              <h2 class="page-title mb-md-0 mb-3">
                <a href="javascript:void(0)"
                  ><img
                    src="/images/back-arrow.svg"
                    width="20"
                    alt=""
                    class="me-2"
                /></a>
                All Notifications
              </h2>
            </div>
            <div class="col-md-8 form-style d-flex justify-content-end"></div>
          </div>
          <div class="table-wrap" v-show="!loader">
            <table class="table table-style-1 table-responsive table-hover">
              <tbody>
                <tr
                  class="border-bottom"
                  v-for="(data, index) in list"
                  :key="index"
                >
                  <td style="margin:0px;!important">
                    <div>
                      >
                      <img
                        :src="
                          data.to_user && data.to_user.image
                            ? data.to_user.image
                            : 'img/profile.svg'
                        "
                        width="35"
                        height="35"
                        class="rounded-circle object-cover"
                        alt=""
                      />
                    </div>
                  </td>
                  <td>
                    <p style="margin:0px;!important">
                      {{ data.description }}
                    </p>

                    <span class="d-block font-12 text-secondary">{{
                      data.created_at
                        ? this.$helperService.getFormatedDateAndTime(
                            data.created_at
                          )
                        : ""
                    }}</span>
                  </td>
                  <td class="text-end">
                    <a
                      v-on:click="
                        $router.push('/profile-view/' + data.reference_id)
                      "
                      class="btn btn-outline-brand-1 btn-sm"
                      style="
                        height: 25px;
                        padding: 5px;
                        line-height: 21px;
                        height: 31px;
                      "
                      >VIEW
                      <i class="fa fa-long-arrow-right" aria-hidden="true"></i
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mx-0 mb-4">
            <div class="col-lg-12 mt-5 text-end">
              <div class="page-bottom-pagination">
                <Pagination
                  @page-change="pageChange"
                  @items-per-page-change="itemsPerPageChange"
                  ref="listPagination"
                />
              </div>
            </div>
          </div>
          <ErrorComponent @retry="getList(0)" ref="errorComponent" />
        </div>
      </div>
    </main>

    <MainFooter />
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import InnerHeader from "@/components/InnerHeader";
import MainFooter from "@/components/MainFooter";

export default {
  name: "AllNotifications",
  components: {
    InnerHeader,
    MainFooter,
    ErrorComponent,
    Pagination,
  },
  data() {
    return {
      loader: false,
      offset: -1,
      keyword: "",
      searchObj: {},
      list: [],
    };
  },
  mounted() {
    this.getList(0);
      this.$access_token = localStorage.getItem("access_token");
    if (this.$access_token) {
      this.getUnreadCount();
    }
  },
  methods: {
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(offset, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.loader = true;
      this.list = [];
      this.searchObj.offset = offset;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/user/notification/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.count = res.count;
          this.list = res.list;
          this.offset = res.next_offset;
          if (offset == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(
              res,
              "Notification List Not Available"
            );
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined);
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    getNotification(offset) {
      this.loader = true;
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateListLoader(true);
      }

      this.searchObj.offset = offset;
      if (offset == 0) {
        this.notificationList = [];
      }
      this.$api
        .getAPI({
          _action: "/user/notification/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.length = res.count;
          this.notificationList = res.list;
        })
        .catch(() => {});
    },
    getUnreadCount() {
      var access_token = localStorage.getItem("access_token");
      if (access_token) {
        this.$api
          .getAPI({
            _action: "/notification/count",
          })
          .then((res) => {
            this.count = res.count;
          })
          .catch(() => {});
      }
    },
  },
};
</script>
